module.exports = __webpack_public_path__ + "static/media/bg-card-service-3.863d1dc9.gif";